const characterListSelector = state => {
  return state.entities.characters.allIds.map(
    c => state.entities.characters.byId[c],
  );
};

export default {
  characterListSelector,
};
